import React from "react";
import "../redeem-voucher/RedeemVoucher.scss";
import * as PR from "../../prime-modules/index";
import { useToast } from "../../context/ToastContext";

const RedeemVoucherTopUp = ({ voucherTopUpData, createOrTopupEsim }) => {
  const { redeemVoucher, account } = useToast();

  return (
    <>
      <div className="vouchers-box">
        <div className="topup-esim text-center">
          <h2>{redeemVoucher.VOUC012}</h2>
          {voucherTopUpData && voucherTopUpData?.esims?.map(v => {
            return (
              <div className="esim-list" key={v?.iccid}>
                <div className="flex align-items-center justify-content-between">
                  <div className="left">
                    <p>{account.ACT0015}: {v?.tag}</p>
                    <span>{account.ACT0023} : {v?.iccid}</span>
                  </div>
                  <div className="right">
                    <PR.Button label={redeemVoucher.VOUC010} type='submit' className="topup-btn" onClick={() => createOrTopupEsim(v?.iccid)} />
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </>
  );
};

export default RedeemVoucherTopUp;